import React from "react";
import "./menu.css";
import Lunch from "../../Assets/RP-L.jpg"
import Breakfast from "../../Assets/RP-B.jpg"
import Drink from "../../Assets/RP-D.jpg"

function Menu() {
  return <div className="menu-container">
    <img src={Breakfast} alt="Breakfast Menu" className="menu-img"/>
    <img src={Lunch} alt="Lunch Menu" className="menu-img"/>
    <img src={Drink} alt="Drink Menu" className="menu-img"/>
  </div>;
}

export default Menu;
